export const ZINDEX = {
  APP_CONTENT: 15,
  SIDEBAR: 16,
  HEADER: 17,
};
